@if (!isPrint) {
  <top-bar></top-bar>
}
<app-notifications></app-notifications>
<router-outlet></router-outlet>
